import * as types from '../actions/types';
import initialState from './initialState';



export default function runsReducer(state = initialState.run, action) {
  switch (action.type) {
    case types.GET_RUN_SUCCESS:
      return {
        ...state,
        ...action.payload
      }
    case types.GET_ALLOCATIONS_SUCCESS:
      return {
        ...state,
        allocations: action.payload
      }
    case types.GET_FINISHED_COMPUTATIONS_SUCCESS:
      return {
        ...state,
        finishedComputations: action.payload
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/runReducer.js